import React, { useState } from "react";
import ImageScrollGallery from "../components/ImageScrollGallery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import test1 from "../assets/iog.jpg";
import test2 from "../assets/jesm.png";
import test3 from "../assets/zpbr.png";
import Message from "../components/Message";

const JournalsPage = () => {
  const [message, setMessage] = useState(null);
  const showMessage = (content) => {
    setMessage(content);
    setTimeout(() => setMessage(null), 2000);
  };

  // ✅ 核心修改：将journals替换为包含图片的数组，isComingSoon设为false
  const [journals] = useState([
    { 
      id: "1", 
      title: "Journal-1", 
      img: test1,  // 关联test1图片
      isComingSoon: false 
    },
    { 
      id: "2", 
      title: "Journal-2", 
      img: test2,  // 关联test2图片
      isComingSoon: false 
    },
    { 
      id: "3", 
      title: "Journal-3", 
      img: test3,  // 关联test3图片
      isComingSoon: false 
    },
  ]);

  // 渐变方向数组（保留，供可能的其他卡片使用）
  const gradientDirections = [
    "at bottom right",
    "at top left",
    "at top right",
    "at bottom left",
  ];

  return (
    <div>
      {message && <Message content={message} onClose={() => setMessage(null)} />}

      <div className="page-title">
        <h1>Explore Our Journals</h1>
      </div>

      <div className="row">
        {journals.map((journal, index) => {
          const direction = gradientDirections[index % gradientDirections.length];
          return (
            <div key={journal.id} className="col-md-4 mb-4">
              {journal.isComingSoon ? (
                <div
                  className="card card-tab shadow-sm hover:shadow-md transition-shadow duration-300"
                  onClick={() => showMessage("This journal is coming soon!")}
                  style={{
                    cursor: "pointer",
                    backgroundImage: `radial-gradient(${direction}, #000000 40%, #003366 100%)`,
                    borderRadius: "8px",
                    color: "#fff",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    padding: "0",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className="text-center">
                      <div
                        style={{
                          marginBottom: "1rem",
                          fontWeight: 600,
                          fontSize: "1.1rem",
                        }}
                      >
                        {journal.title}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <a
                  // href={`journal/${journal.id}`} 
                  className="text-decoration-none text-dark"
                  onClick={() => showMessage(`In Preparation`)}
                >
                  <div 
                    className="card p-0 card-tab shadow-sm hover:shadow-md transition-shadow duration-300"
                  >
                    <div className="bg-gray-100">
                      <img
                        src={journal.img}
                        className="card-img-top"
                        alt={journal.title}
                        style={{
                          objectFit: "cover",  // 改为cover，避免图片拉伸变形
                          width: "100%",       // 确保图片占满卡片宽度
                        }}
                      />
                    </div>
                  </div>
                </a>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default JournalsPage;